function maskPhone(number: string, pattern: string) {
  const numeros = number.replace(/\D/g, '')

  let indexNumber = 0
  let formattedNumber = ''

  for (let i = 0; i < pattern.length; i++) {
    if (pattern[i] === 'X') {
      formattedNumber += numeros[indexNumber] || ''
      indexNumber += 1
    } else {
      if (formattedNumber.length <= numeros.length) {
        formattedNumber += pattern[i]
      }
    }
  }

  return formattedNumber
}

export default maskPhone
